import React from "react";
import { useTranslation } from "react-i18next";
import { MdPersonAdd } from "react-icons/md";

export interface SurveyAccountAddOptionProps {
  onClick: () => void;
}

const SurveyAccountAddOption: React.FC<SurveyAccountAddOptionProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="survey-account-select__option survey-account-select__option--add"
      onClick={onClick}
    >
      <div className="survey-account-select__option-avatar survey-account-select__option-avatar--add" aria-hidden>
        <MdPersonAdd />
      </div>
      <div className="survey-account-select__option-content">
        <span className="survey-account-select__option-name">{t("survey_account_add_person")}</span>
        <span className="survey-account-select__option-meta body-text-small text-color-dark-gray">
          {t("survey_account_add_another_hint")}
        </span>
      </div>
    </button>
  );
};

export default SurveyAccountAddOption;
